import { useFetchRecentlyPlayedLectures } from '../../lib/fetches.ts';
import LastPlayedLectureCard from '../cards/LastPlayedLectureCard.tsx';
import Skeleton from '../Skeleton.tsx';
import { cn } from '../../lib/helpers.ts';

export function LastPlayedLectures() {
    const { data: recommendedLectures, isLoading } =
        useFetchRecentlyPlayedLectures();

    return (recommendedLectures && recommendedLectures.length > 0) ||
        isLoading ? (
        <div className="pb-16">
            <h2 className="mb-6">Naposledy přehráno</h2>
            <div
                className={cn(
                    'grid gap-8',
                    'flex justify-start',
                    (recommendedLectures?.length ?? 0) >= 4 && 'justify-between'
                    // 'grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4'
                    // 'overflow-x-hidden',
                    // '-mx-10 -mb-4 px-10 pb-4'
                )}
            >
                {recommendedLectures
                    ?.slice(0, 4)
                    ?.map(
                        ({
                            name,
                            slug,
                            category: {
                                name: categoryName,
                                color,
                                slug: categorySlug,
                            },
                            video: { poster },
                        }) => (
                            <LastPlayedLectureCard
                                key={slug}
                                href={`/cviceni/lekce/${categorySlug}#${slug}`}
                                color={color}
                                heading={name}
                                subheading={categoryName}
                                poster={poster}
                            />
                        )
                    )}

                {isLoading && (
                    <Skeleton count={4} className="h-64 w-[248px] rounded-xl" />
                )}

                {/* Gradient for disappearing */}
                {/*<div className="absolute right-0 h-64 w-10 bg-gradient-to-r from-transparent to-base-100" />*/}
            </div>
        </div>
    ) : null;
}
